import { apiProxyRequest } from "Api/apiProxyRequest";

import type { BillingAccountMappingWithLinks } from "../types";

export const getBillingAccountRequest = (billingAccountId: string) => {
  return apiProxyRequest<BillingAccountMappingWithLinks>(
    `/billing/accounts/${billingAccountId}`
  );
};
